<script setup lang="ts">
import { mdiLoading } from '@mdi/js'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  title: string
  disabled?: boolean
  readonly?: boolean
  loading?: boolean
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <button
    type="button"
    tabindex="-1"
    class="peer outline-none disabled:text-gray-400 disabled:fill-gray-300 disabled:shadow-none not-disabled:cursor-pointer not-disabled:fill-gray-700"
    :title="title"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <SvgIcon v-if="loading" :path="mdiLoading" class="fill-gray-700 animate-spin h-5 w-5" />
    <slot v-else></slot>
  </button>
</template>
